export default function ({ store, redirect }) {
  // If the user is not authenticated
  if (store.state.featured) {
    return redirect('/d/' + store.state.featured + '/share')
  }
}
